import { FormikProps } from "formik";
import { useEffect, useMemo, useRef } from "react";
import { Form2Payload } from "@/pages/app/provider/scheduling/appointment/encounter/encounter-constant";
import { InitialF2fPayload } from "../initial-f2f-types";
import { toStructuredCodes } from "../initial-f2f-utils";

interface UseCodeFieldsSyncParams {
  formik: FormikProps<Form2Payload>;
  payload: InitialF2fPayload;
}

/** Mirrors the picked Diagnosis and CPT codes into the encounter's `assessmentCodes` and `procedureCodes`, which sign validation and the report read. */
export const useCodeFieldsSync = ({
  formik,
  payload,
}: UseCodeFieldsSyncParams): void => {
  const { setFieldValue } = formik;
  const diagnosis = useMemo(
    () => toStructuredCodes(payload.diagnosisCodes),
    [payload.diagnosisCodes]
  );
  const cpt = useMemo(
    () => toStructuredCodes(payload.cptCodes),
    [payload.cptCodes]
  );
  const lastDiagnosis = useRef(JSON.stringify(diagnosis));
  const lastCpt = useRef(JSON.stringify(cpt));

  useEffect(() => {
    const serialized = JSON.stringify(diagnosis);
    if (serialized === lastDiagnosis.current) return;
    lastDiagnosis.current = serialized;
    setFieldValue("assessmentCodes", diagnosis);
  }, [diagnosis, setFieldValue]);

  useEffect(() => {
    const serialized = JSON.stringify(cpt);
    if (serialized === lastCpt.current) return;
    lastCpt.current = serialized;
    setFieldValue("procedureCodes", cpt);
  }, [cpt, setFieldValue]);
};
